const tryGetString = (context) => {
  const stringToken = context == null ? void 0 : context.STRING();
  if (stringToken == null) {
    return { value: "", success: false };
  }
  const originalToken = stringToken.text.replace('\\"', '"');
  const value = originalToken.substring(1, originalToken.length - 1);
  return { value, success: true };
};
const tryGetInteger = (context) => {
  const integerToken = context == null ? void 0 : context.INTEGER();
  if (integerToken == null) {
    return { value: 0, success: false };
  }
  const value = +integerToken.text;
  return { value, success: true };
};
const tryGetBoolean = (context) => {
  let value;
  if ((context == null ? void 0 : context.BOOL_TRUE()) !== null) {
    value = true;
  } else if ((context == null ? void 0 : context.BOOL_FALSE()) !== null) {
    value = false;
  } else {
    return { value: false, success: false };
  }
  return { value, success: true };
};
const tryGetVersion = (context) => {
  const versionToken = context == null ? void 0 : context.VERSION();
  if (versionToken == null) {
    return { value: "1.0.0", success: false };
  }
  const versionString = versionToken.text;
  return { value: versionString, success: true };
};
export {
  tryGetBoolean,
  tryGetInteger,
  tryGetString,
  tryGetVersion
};
//# sourceMappingURL=FilterExpressionParser.utils.js.map
